class Monitoring.Views.FormLabelView extends Backbone.View
  template: JST["backbone/templates/monitoring/label_admin/form_label"]
  modalContainerTemplate: JST["backbone/templates/monitoring/label_admin/modal_container"]

  newInstancesCounter: 0;

  events :
    'click #btn-create': 'onSaveLabel'

  initialize: (@options = {}) ->
    @labels = @options.labels
    @label = @options.label
    @topic = @options.topic
    @keywordView = destroy: ->

  destroy: ->
    @keywordView.destroy()
    @label = undefined
    @allLabels = []
    this.remove()
    return false

  render: ->
    @$el.html(@template(
      formName: @formName,
      labels: @labels.toJSON(),
      label: if @label then @label.toJSON() else null))
    keywords = if @label then @label.get('keywords') else new Monitoring.Collections.KeywordsCollection()
    @keywordView = new Monitoring.Views.KeywordView(keywords: keywords, labels: @labels, title: 'Add a keyword')
    @$el.find('.add-keywords').html(@keywordView.render().el)

    return this

  modal: ->
    @render()
    @modalContainer = $(@modalContainerTemplate())
    @modalContainer.find('.modal-body').html(@el)
    @modalContainer.modal()

    return this

  onSaveLabel: =>
    @$el.find('#btn-create').attr("disabled", "disabled");
    parent_id = if @$el.find('#nest-inside').val() != 'null' then parseInt(@$el.find('#nest-inside').val()) else null
    label = if @label then @label else new Monitoring.Models.Label()
    label.set({
      name: @$el.find('#label-name').val()
      parent_id: parent_id
      keywords: @keywordView.keywords
    })

    label.set(
      'keywords_attributes': @keywordView.getKeywordsAttributes()
    )

    if @options.save
      label.save(
            success: (label) =>
              if !label.get('error')
                @onSuccess(label, parent_id)
            error: (error) =>
              alert(error)
          )
    else
      if !label.get('id')
        id = -(++FormLabelView.prototype.newInstancesCounter)
        label.set('id', id)
      @onSuccess(label, parent_id)

    return true

  onSuccess: (label, parent_id) ->
    @labels.remove(label, false)
    if parent_id != null
      @labels.addAsChild(label, parent_id)
    else
      @labels.add(label)
    if @modalContainer
      @modalContainer.modal('hide')
